import React from 'react';
import PropTypes from 'prop-types';
import Translate from './Translate';
import Tooltip from './Tooltip';
import VariableCost from './VariableCost';
import VariableCostsHOC from '../hoc/VariableCostsHOC';

const VariableCosts = ({services}) => (
  <div className="variable-costs">
    <h4 className="variable-costs__title">
      <Translate content="Variable expenses" />
      <Tooltip>
        <Translate content="Any variable costs listed in this section are paid in local currency at the destination" />
      </Tooltip>
    </h4>
    <ul className="titled-list variable-costs__titled-list">
      {services.map((service, i) => (
        <li className="titled-list__item" key={i}>
          <VariableCost service={service} />
        </li>
      ))}
    </ul>
  </div>
);

VariableCosts.PropTypes = {
  services:PropTypes.array.isRequired,
};

export default VariableCostsHOC(VariableCosts);
